import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

export const CurrencySelect = ({ value, onChange }) => {
  return (
    <FormControl variant="standard" fullWidth>
      <InputLabel id="currency-select-label">Devise</InputLabel>
      <Select
        labelId="currency-select-label"
        id="currency-select"
        value={value || 'EUR'}
        onChange={(e) => onChange(e.target.value)}
        label="Devise"
      >
        <MenuItem value="EUR">EUR (€)</MenuItem>
        <MenuItem value="MAD">MAD (د.م)</MenuItem>
        <MenuItem value="TND">TND (د.ت)</MenuItem>
        <MenuItem value="EGP">EGP (£E)</MenuItem>
      </Select>
    </FormControl>
  );
};

export const countryToCurrency = {
  France: 'EUR',
  Morocco: 'MAD',
  Tunisie: 'TND',
  Tunisia: 'TND',
  Égypte: 'EGP',
  Egypt: 'EGP',
};